import React, { Component } from "react";
import DefaultComponent from "../util/StyledComponents/DefaultComponent";
class Reports extends Component {
  render() {
    return <DefaultComponent>REPORTS</DefaultComponent>;
  }
}

export default Reports;
